import { Button } from '@hotjar/hotsauce';
import * as React from 'react';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { Trans } from 'react-i18next';
import { VerifyEmailPageStyles } from './style';
import type { StepProps } from './types';

const { Title, ActionBar, Description } = VerifyEmailPageStyles;

export const Step1 = ({ email, onBack, onNext }: StepProps): React.ReactElement<StepProps> => {
  const { t } = useTranslationWithPrefix('auth:enforce-mfa-verify-email:step1');

  return (
    <>
      <Title>{t('title')}</Title>
      <Description>
        <Trans i18nKey="auth:enforce-mfa-verify-email:step1:description">
          <strong>{email}</strong>
        </Trans>
      </Description>
      <ActionBar>
        <Button kind="secondary" onClick={onBack}>
          {t('back')}
        </Button>
        <Button kind="primary" onClick={onNext} type="submit">
          {t('action')}
        </Button>
      </ActionBar>
    </>
  );
};
